module.exports = __webpack_public_path__ + "static/img/6.8aa0baf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/6.png
// module id = ylMe
// module chunks = 0